import React from 'react'

interface MicrophoneLoaderProps {
  color?: string
}

const MicrophoneLoader = ({ color }: MicrophoneLoaderProps): JSX.Element => {
  return (
    <div className='rf-w-full rf-h-full rf-bg-transparent'>
      {/* Animation */}
      <div
        className={`rf-w-full rf-h-full rf-relative rf-rounded-max rf-mx-0 rf-my-auto ${
          color === 'primary'
            ? 'rf-loader-microphone-primary'
            : color === 'secondary'
            ? 'rf-loader-microphone-secondary'
            : 'rf-loader-microphone'
        }`}
        style={{
          borderTopColor: color || '#FFF'
        }}
      />
    </div>
  )
}

export default MicrophoneLoader
